import JsEncrypt from 'jsencrypt'
import {publicKey} from '@vars/global_vars'

let jse = new JsEncrypt()
jse.setPublicKey(publicKey)

export const passEncrypt = (password) => jse.encrypt(password)

